import styled from "styled-components";

export const SupportContainer = styled.div`
  display: flex;
  height: calc(100vh - var(--navbar-height, 60px));
  overflow: hidden; /* Previene scroll general de la página */
  background-color: #F1F2F8;
  font-family: var(--font-body);
`;

export const LeftPanel = styled.div`
  flex: 1;
  background-color: #2b3a4a;
  background-image: url("${props => props.$bgImage}");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: none;

  @media (min-width: 900px) {
    display: block;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #f8f9fa;
  overflow-y: auto; /* Si la pantalla es diminuta, solo scrollea el panel, no la foto */
`;

export const SupportCard = styled.div`
  background-color: #FFFFFF;
  width: 100%;
  max-width: 500px;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  text-align: center;
  box-sizing: border-box;
`;

export const Title = styled.h2`
  color: #545454;
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 12px;
  font-weight: 700;
`;

export const InfoBox = styled.div`
  background-color: #FCF8F8;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.4;
  color: #545454;
  margin-bottom: 16px;
  text-align: left;
  border-left: 4px solid #545454;

  a {
    color: #545454;
    text-decoration: underline;
    font-weight: bold;
    word-break: break-all;
  }

  a:hover {
    color: #000000;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 10px;
  text-align: left;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #CFD8DC;
  border-radius: 8px;
  background-color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 13px;
  box-sizing: border-box;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #545454;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #CFD8DC;
  border-radius: 8px;
  background-color: #FFFFFF;
  font-family: var(--font-body);
  font-size: 13px;
  box-sizing: border-box;
  color: #000000;
  resize: vertical;
  min-height: 70px;
  outline: none;

  &:focus {
    border-color: #545454;
  }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 12px;
  background-color: #545454;
  color: #FFFFFF;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s ease;

  &:hover {
    background-color: #3d3d3d;
  }

  &:disabled {
    background-color: #9e9e9e;
    cursor: not-allowed;
  }
`;

export const RequiredFooter = styled.span`
  color: #DA291C;
  font-size: 11px;
  margin-top: 10px;
  display: block;
`;
